import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Container = styled.div`
  padding: 0 16px;
`;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;

const Paragraph = styled.p`
  margin-bottom: 16px;
  line-height: 1.6;
`;

const InsuranceAndPayments: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="InsuranceAndPayments">
      <Title>{t("InsuranceAndPayment.title").toUpperCase()}</Title>
      <Paragraph>{t("InsuranceAndPayment.healthInsurance")}</Paragraph>
      <Paragraph>{t("InsuranceAndPayment.payments")}</Paragraph>
      <Paragraph>
        {t("InsuranceAndPayment.contact")} <strong>619-754-9500</strong>{" "}
        {t("InsuranceAndPayment.orEmail")}{" "}
        <a href="mailto:billing@communitycardiologyclinic.com">
          billing@communitycardiologyclinic.com
        </a>
        .
      </Paragraph>
    </Container>
  );
};

export default InsuranceAndPayments;
